const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}




// Instagram js

document.addEventListener("DOMContentLoaded", () => {
  function initFeed() {
    const titles = document.querySelectorAll(".instastory-title");
titles.forEach((title) => {
  title.style.display = "none";
});

    const feed = document.querySelector("#instafeed .instagram-grid-container");
    if (!feed) return false;

    const items = Array.from(feed.querySelectorAll(".instagram-grid-item"));
    if (items.length < 2) return false;

    // Chỉ giữ 8 items (4x2)
    items.forEach((item, i) => {
      if (i >= 8) item.style.display = "none";
    });

    const mobile = window.matchMedia("(max-width: 767px)");

    function applyStyles() {
      const isMobile = mobile.matches;
      const cols = isMobile ? 3 : 4;
      const visibleCount = isMobile ? 6 : 8;

      items.forEach((item, i) => {
        item.style.display = i < visibleCount ? "" : "none";
      });

      feed.style.cssText = `
      width: 100%;
      max-width: 1400px;
        display: grid !important;
        grid-template-columns: repeat(${cols}, 1fr) !important;
        grid-auto-rows: 1fr !important;
        gap: 10px !important;
        padding: 10px !important;
        overflow: unset !important;
        flex-wrap: unset !important;
        scroll-snap-type: unset !important;
      `;

      items.slice(0, visibleCount).forEach((item) => {
        item.style.cssText = `
          aspect-ratio: 3 / 4 !important;
          width: 100% !important;
          overflow: hidden !important;
          position: relative !important;
        `;
      });
    }

    mobile.addEventListener("change", applyStyles);
    applyStyles();
    return true;
  }

  if (!initFeed()) {
    const observer = new MutationObserver(() => {
      if (initFeed()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});